import { useTranslation } from 'react-i18next'
import { IconContext } from 'react-icons'
import { MdKeyboardArrowRight } from 'react-icons/md'

import { iconsEntriesMock } from '../../mock/iconsEntriesMock.tsx'
import { cn } from '../../utils/classnames.ts'

interface IconSelectorListProps {
  onSelect: (iconName: string) => void
  searchQuery: string
}

export const IconSelectorList = ({
  onSelect,
  searchQuery,
}: IconSelectorListProps) => {
  const iconsEntries = iconsEntriesMock
  const { t } = useTranslation()

  const handleIconClick = (iconName: string) => {
    onSelect(iconName)
  }

  const filteredIcons = iconsEntries.filter(({ name }) =>
    name.toLowerCase().includes(searchQuery.toLowerCase()),
  )

  return (
    <IconContext.Provider value={{ size: '24px' }}>
      {filteredIcons
        .slice(0)
        .map(({ icon, name, enabled }) => (
          <div
            key={name}
            className="flex cursor-pointer items-center justify-between px-2 py-3 hover:bg-blue-50"
            onClick={() => handleIconClick(name)}
          >
            <div className="flex items-center gap-3.5">
              <div className="h-6 w-6">{icon}</div>
              <span className="text-sm">{name}</span>
            </div>

            <div className={cn({ 'text-themePrimary': enabled })}>
              {enabled ? t('alreadyAdded') : <MdKeyboardArrowRight />}
            </div>
          </div>
        ))}
    </IconContext.Provider>
  )
}
